import { render, staticRenderFns } from "./TransferInBalanceModal.vue?vue&type=template&id=1234d714&"
import script from "./TransferInBalanceModal.vue?vue&type=script&lang=js&"
export * from "./TransferInBalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports